import { AdvancedFeasibilityFilters, UniqueLinksForm } from '@ps/survey-utils';

export interface ChildSwitchContext {
  readonly advancedFilters: AdvancedFeasibilityFilters;
  readonly isRespondentStatusFilterEnabled: boolean;
  readonly isManualProcessingEnabled: boolean;
  readonly isFeasibilityLoading: boolean;
  readonly isUniqueLinksEnabled: boolean;
  readonly uniqueLinksCount: number;
  readonly hasFeotQuotaViolation: boolean;
}

export type ChildSwitchContextSources = Omit<
  ChildSwitchContext,
  'isUniqueLinksEnabled' | 'uniqueLinksCount'
> & {
  readonly uniqueLinks: UniqueLinksForm;
};

export function buildChildSwitchContext({
  advancedFilters,
  isRespondentStatusFilterEnabled,
  isManualProcessingEnabled,
  isFeasibilityLoading,
  hasFeotQuotaViolation,
  uniqueLinks,
}: ChildSwitchContextSources): ChildSwitchContext {
  return {
    advancedFilters,
    isRespondentStatusFilterEnabled,
    isManualProcessingEnabled,
    isFeasibilityLoading,
    isUniqueLinksEnabled: uniqueLinks.uniqueLinksEnabled,
    uniqueLinksCount: uniqueLinks.entryLinks.length,
    hasFeotQuotaViolation,
  };
}
